// import { param } from "jquery";

export default function actionButtons(inputConfig) {

    function render(params) {
        const $containerButtons = document.createElement('div');

        $containerButtons.classList.add('flex');

		const $checkbox = document.createElement('div');
		$checkbox.classList.add(
			"vs-component",
			"con-vs-checkbox",
			"vs-checkbox-primary",
			"vs-checkbox-default"
		);

		if (inputConfig) {

			const $inputCheckbox = document.createElement("input");
			$inputCheckbox.setAttribute("type", "checkbox");
			$inputCheckbox.classList.add("vs-checkbox--input");
			$inputCheckbox.checked = params.value;

			$checkbox.innerHTML = `
				<span class="checkbox_x vs-checkbox" style="border: 2px solid rgb(180, 180, 180);">
					<span class="vs-checkbox--check">
						<i class="vs-icon notranslate icon-scale vs-checkbox--icon  material-icons null">
							check
						</i>
					</span>
				</span>
			`;

			$inputCheckbox.onchange = function() {

				if (inputConfig.change && inputConfig.field && typeof inputConfig.field == "string") {
					$inputCheckbox.setAttribute("name", inputConfig.field);
					params.data[inputConfig.field] = $inputCheckbox.checked;
					inputConfig.change(params.data);
				}
			}

			$checkbox.prepend($inputCheckbox);
		}

        return $checkbox;
    }

    return render;

}
